import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'cyberScoreChart',
  props: {
    currentScore: { default: 0 },
    potentialScore: { default: 0 },
    totalScore: { default: 1 },
    pcntScore: { default: 0 },
    color: {},
    colorDefault: {}
  },
  setup(__props: any) {

const props = __props;



const optionsCurrent = computed(() => ({
  colors: [props.color],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "70%",
      },
      track: {
        background: props.colorDefault,
        startAngle: -90,
        endAngle: 90,
        show: true,
      },
      dataLabels: {
        name: {
          show: false,
          offsetY: 0,
        },
        value: {
          color: props.color,
          fontSize: "50px",
          fontWeight: 500,
          show: true,
          offsetY: 0,
          formatter: () => `${toFixed(props.pcntScore)}%`,
        },
      },
    },
  },
  stroke: {
    lineCap: "round",
    opacity: 1,
  },
  fill: {
    opacity: 1,
  },
  labels: ["current"],
}));

const optionsPotential = {
  colors: ["#FEE5E2"],
  plotOptions: {
    radialBar: {
      startAngle: -90,
      endAngle: 90,
      hollow: {
        size: "70%",
      },
      track: {
        background: "#F1F2F3",
        startAngle: -90,
        endAngle: 90,
      },
      dataLabels: {
        name: {
          show: false,
          offsetY: 0,
        },
        value: {
          color: "#211F58",
          fontSize: "50px",
          fontWeight: 500,
          show: false,
          offsetY: 0,
        },
      },
    },
  },
  stroke: {
    lineCap: "round",
  },
  labels: ["potential"],
};

const seriesCurrent = computed(() => {
  const current = toFixed((props.currentScore * 100) / props.totalScore);
  return [current];
});

const seriesPotential = computed(() => {
  const potential = toFixed((props.potentialScore * 100) / props.totalScore);
  return [potential];
});

const toFixed = (num: number, digit = 2) => {
  let output = (num || 0).toFixed(digit);
  while (output[output.length - 1] === "0") {
    output = output.slice(0, -1);
  }
  if (output[output.length - 1] === ".") {
    output = output.slice(0, -1);
  }
  return output;
};

return (_ctx: any,_cache: any) => {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_apexchart, {
      class: "score-chart-current",
      width: "339px",
      type: "radialBar",
      options: optionsCurrent.value,
      series: seriesCurrent.value
    }, null, 8, ["options", "series"]),
    _createVNode(_component_apexchart, {
      width: "339px",
      type: "radialBar",
      options: optionsPotential,
      series: seriesPotential.value
    }, null, 8, ["series"])
  ], 64))
}
}

})